import script from "./BotComposer.vue?vue&type=script&setup=true&lang=js"
export * from "./BotComposer.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import GlowFrame from "@/components/catering/GlowFrame.vue";
script.components = Object.assign({}, { GlowFrame }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { GlowFrame }, script.__o.components);}